export default __webpack_public_path__ + "static/media/create-article.b4ed85a6.png";